import { observer } from 'mobx-react'
import React, { forwardRef } from 'react'
import { Block, Heading } from 'suomifi-ui-components'
import { finalEditableFieldValue } from 'todistukset-common/src/vtj/types/editable-field.type'
import LocalizedString, {
  LocalizedParagraphs,
} from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import { FormContainer } from 'todistukset-ui/src/vtj/components/order-wizard/CommonFormComponents.sc'
import type { StepComponent } from 'todistukset-ui/src/vtj/components/order-wizard/OrderWizardStep.type'
import { useAetSignerForm } from 'todistukset-ui/src/vtj/stores/aet-signer-form.store'

const AetInstructionsStep: StepComponent = observer(
  forwardRef(function AetInstructionsStep({ titleId }, _ref) {
    const form = useAetSignerForm()
    if (!form.aetTodistuspyynto || form.isLoading) {
      return <></>
    }
    const {
      orderer: { firstNames, lastName },
    } = form.aetTodistuspyynto

    const ordererFullName = `${finalEditableFieldValue(
      firstNames
    )} ${finalEditableFieldValue(lastName)}`

    return (
      <FormContainer>
        <Block variant="section">
          <Heading variant="h2" id={titleId}>
            <LocalizedString stringKey="aetSignerInstructionsMainTitle" />
          </Heading>
          <LocalizedParagraphs
            stringKey="aetSignerInstructionsMainDescription_paragraphs"
            values={{ ordererFullName }}
          />
        </Block>
        <Block variant="section">
          <Heading variant="h3">
            <LocalizedString stringKey="aetSignerInstructionsInformationTitle" />
          </Heading>
          <LocalizedParagraphs stringKey="aetSignerInstructionsInformationDescription_paragraphs" />
        </Block>
      </FormContainer>
    )
  })
)

export default AetInstructionsStep
